<template>
  <div>
    <collapse :multiple-active="false" :active-index="-1">
      <collapse-form-item
        id="bankingInformationStep"
        title="Banking Information"
        @tabOpen="loadItem"
        :status="bankingInformationStatus"
        v-bind:tabChange="getAllState.bill"
        name="2"
      >
        <div>
          <banking-information
            :is-read-only="isReadOnly"
            ref="bankingInformationStep"
            @validated="onSubStepValidated"
          ></banking-information>
        </div>
      </collapse-form-item>
      
    </collapse>
  </div>
</template>

<script>
import FinanceInformation from "@/components/App/order/bill/FinanceInformation.vue";
import BankingInformation from "@/components/App/order/bill/BankingInformation.vue";
import { Select, Option } from "element-ui";
import { BaseRadio, Collapse, CollapseFormItem } from "@/components/index";
import { mapGetters, mapActions } from "vuex";
import { EventBus } from "@/event-bus.js";

export default {
  props: ["isReadOnly"],
  name: "Bill",
  components: {
    FinanceInformation,
    BankingInformation,
    Collapse,
    CollapseFormItem,
    [Select.name]: Select,
    [Option.name]: Option,
    BaseRadio,
  },
  data() {
    return {
      status: null,
    };
  },
  mounted() {
    this.getFinanceInformationStatus(this.$route.params.id);
    this.getBankingInformationStatus(this.$route.params.id);
    this.getFinancialRepresentativeStatus(this.$route.params.id);
  },
  computed: {
    ...mapGetters({
      financeInformationStatus: "financeInformation/financeInformationStatus",
      bankingInformationStatus: "bankingInformation/bankingInformationStatus",
      financialRepresentativeStatus: "financialRepresentative/financialRepresentativeStatus",
      orderStatus: "orderMetadata/orderStatus",
      getAllState: "moduleState/getAllStates"
    }),
  },
  methods: {
    ...mapActions({
      getFinanceInformationStatus:
        "financeInformation/getFinanceInformationStatus",
      getBankingInformationStatus:
        "bankingInformation/getBankingInformationStatus",
      getFinancialRepresentativeStatus: "financialRepresentative/getFinancialRepresentativeStatus",
      submitBilled: "orderMetadata/submitBilled",
    }),
    onSubStepValidated(validated, model) {
      this.$emit("on-validated", validated, model);
    },
    loadItem(ref) {
      return this.$refs[ref].loaded();
    },
    showDocumentTab() {
      this.$emit("show-document-tab");
      EventBus.$emit('clicked-from', 'BILL')
    },
    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit("on-validated", res, this.model);
        return res;
      });
    },
  },
};
</script>

<style scoped>
@import "../../../styles/custom_grid.css";

.card-collapse .card.card-plain.has-danger .card-header:after {
  background: #ec250d;
}

.card-collapse .card.card-plain.has-success .card-header:after {
  background: #10b45a;
}
</style>
